'use client';

import EntryRevalidator from '@/components/EntryRevalidator';
import IndexLayout, { type IndexLayoutProps } from '../IndexLayout';
import type { Revalidation } from './revalidation';

export default function RevalidatedIndexLayout({
  uri,
  revalidate = true,
  entry,
  ...props
}: IndexLayoutProps & Revalidation) {
  return (
    <EntryRevalidator {...{ uri, entry, enabled: revalidate }}>
      {(fresh) => <IndexLayout {...props} entry={fresh} />}
    </EntryRevalidator>
  );
}
